<ng-container *ngIf="userService.user$ | async; else awaitingAuth">
  <main [vnmTheme]="themeService.activeTheme" [ngClass]="ngClass$ | async">
    <vnm-sidebar *ngIf="sidebarEnabled$ | async"></vnm-sidebar>
    <section>
      <vnm-topbar *ngIf="topbarEnabled$ | async">
        <button
          type="button"
          pButton
          class="sidenav-button p-button-text p-button-rounded"
          icon="fa fa-fw fa-bars"
          [label]="'app.menu' | translate"
          (click)="onOpenSidebar($event)"
        ></button>
        <vnm-breadcrumb></vnm-breadcrumb>
      </vnm-topbar>
      <vnm-notification-bar *ngIf="notificationsEnabled$ | async"></vnm-notification-bar>

      <article #mainContent [ngClass]="{ 'no-scroll': noScroll$ | async, dashboard: isDashboard$ | async }">
        <router-outlet></router-outlet>
      </article>
    </section>
  </main>
  <p-toast [baseZIndex]="9999"></p-toast>
  <p-confirmDialog
    [header]="'app.confirmation.title' | translate"
    icon="fa fa-exclamation-triangle"
    acceptIcon="fa fa-fw fa-check"
    rejectIcon="fa fa-fw fa-times"
  ></p-confirmDialog>
</ng-container>

<vnm-feature-gate feature="training_manager_nps_survey">
  <ng-template #gated>
    <vnm-display-survey
      [surveyID]="1"
      [closable]="true"
      displayPercentage="1"
      event="training-manager-distribute"
    ></vnm-display-survey>
  </ng-template>
</vnm-feature-gate>

<ng-template #awaitingAuth>
  <vnm-app-distractor></vnm-app-distractor>
</ng-template>
